import css from 'styled-jsx/css'
const styles = css`
  @media (hover: hover) {
    .bookmark-button:hover {
      outline-width: 0px;
      background-color: #3f71b5;
      text-decoration-line: none;
      color: white;
    }
  }
  @media (hover: none) {
    .bookmark-button:active {
      outline-width: 0px;
      background-color: #3f71b5;
      text-decoration-line: none;
      color: white;
    }
  }
`
interface Props {
  text: string
  onClick: () => Promise<void>
  className?: string
}
export const BookmarkButton: React.FC<Props> = ({
  text,
  onClick,
  className = '',
}) => {
  return (
    <>
      <div
        className={`bookmark-button inline-block relative py-[5px] px-[30px] w-[180px] h-[30px] text-[13px] font-normal leading-5 text-center text-[#1d6dcc] align-middle whitespace-nowrap bg-white rounded-[15px] border border-[#1d6dcc] border-solid cursor-pointer ${className}`}
        onClick={onClick}
      >
        {text}
      </div>
      <style jsx>{styles}</style>
    </>
  )
}
